import { XStack, YStack } from '@mythical/ui'
import { SeriesYouMightLike } from 'app/blocks/series-you-might-like'
import CollectionCard, {
  CollectionCardProps,
} from 'app/components/collection/CollectionCard'
import { ContentCarousel } from 'app/components/content/ContentCarousel'
import { Button } from 'app/components/primitive/Button'
import {
  IconChevronLeft,
  IconChevronRight,
} from 'app/components/primitive/Icon'
import Section from 'app/components/structure/Section'
import { useCarouselController } from 'app/hooks/use-carousel-controller'
import React, { useCallback, useMemo } from 'react'

export const SeriesYouMightLikeBlock: React.FC<{
  block: SeriesYouMightLike
}> = ({ block }) => {
  const { title, collections } = block || {}
  const controller = useCarouselController()

  if (!collections || collections?.length === 0) {
    return null
  }

  const items: CollectionCardProps[] = useMemo(
    () =>
      collections.map((collection) => ({
        id: collection.id,
        title: collection?.name || '',
        href: `/collection/${collection.slug}`,
        image: collection?.thumbnail?.sizes?.square?.url || '',
        itemCount: collection?.itemCount || 0,
      })),
    [collections],
  )

  const renderItem = useCallback(
    (item: CollectionCardProps) => <CollectionCard {...item} />,
    [],
  )

  const keyExtractor = useCallback((item: CollectionCardProps) => item.href, [])

  return (
    <Section
      paddedX
      title={title || 'Series You Might Like'}
      customCta={
        <XStack gap="$2" $sm={{ dsp: 'none' }}>
          <Button
            theme="white"
            onPress={controller.scrollToPrevious}
            disabled={!controller.canScrollPrevious}
            aria-label="Previous"
            icon={<IconChevronLeft size={16}  />}
            size="$3.5"
            circular
          />
          <Button
            theme="white"
            onPress={controller.scrollToNext}
            disabled={!controller.canScrollNext}
            aria-label="Next"
            circular
            size="$3.5"
            icon={<IconChevronRight size={16}  />}
          />
        </XStack>
      }
    >
      <YStack $gtSm={{ overflow: 'hidden' }}>
        <ContentCarousel
          controllerRef={controller.carouselRef}
          items={items}
          keyExtractor={keyExtractor}
          renderItem={renderItem}
        />
      </YStack>
    </Section>
  )
}
